module.exports = __webpack_public_path__ + "6247b88bb8836ce0be3eb29884589778.svg";